import React from 'react'
import PropTypes from 'prop-types'
import { Card, CardContent } from '@mui/material'
import i18n from 'simple-react-i18n'
import { CardTitle } from '../../../components/card/NewCard'
import SimpleTextArea from '../../../components/forms/SimpleTextArea'

const RpqsNotesPanel = ({
    notes = '',
    onChange = () => {},
    readMode = true,
}) => (
    <Card>
        <CardTitle title={i18n.notes} />
        <CardContent sx={{ '& textarea.Mui-disabled': { color: 'black', WebkitTextFillColor: 'black' } }}>
            <SimpleTextArea
                value={notes}
                onChange={onChange}
                rows={10}
                disabled={readMode}
            />
        </CardContent>
    </Card>
)

RpqsNotesPanel.propTypes = {
    notes: PropTypes.string,
    onChange: PropTypes.func,
    readMode: PropTypes.bool,
}

export default RpqsNotesPanel
